import { Stack, Typography } from "@mui/material"
import type { DateTime } from "luxon"
import { makeStyles } from "tss-react/mui"

import { LocalizedEnum, LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { useDateTime } from "../../../../localization/useDateTime"

import { ALL_FLOORS, MeetingRoomStatusFilter, MeetingRoomsView } from "../meetingRoomsTypes"

const useStyles = makeStyles()((theme) => ({
    root: {
        display: "none",
        "@media print": {
            display: "flex",
            flexWrap: "wrap",
            color: theme.palette.tailwind.slate[600],
        },
    },
}))

type Props = Readonly<{
    date: DateTime
    view: MeetingRoomsView
    statusFilter: MeetingRoomStatusFilter
    floor: string
    hourLabel: string
    shownRooms: number
    totalRooms: number
    summaryMessages: ReadonlyArray<string>
}>

export function MeetingRoomsPrintSummary({
    date,
    view,
    statusFilter,
    floor,
    hourLabel,
    shownRooms,
    totalRooms,
    summaryMessages,
}: Props) {
    const { classes } = useStyles()
    const dateTimeFactory = useDateTime()

    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing=".5rem"
            className={classes.root}
            useFlexGap
            divider={<Typography variant="body2">&middot;</Typography>}
        >
            <Typography variant="body2">{dateTimeFactory.formatWeekdayLongDate(date)}</Typography>
            <LocalizedEnum base="service-center-meeting-rooms-view" enumValue={view}>
                <Typography variant="body2">{view}</Typography>
            </LocalizedEnum>
            {statusFilter !== MeetingRoomStatusFilter.ALL && (
                <LocalizedEnum base="service-center-meeting-rooms-status-filter" enumValue={statusFilter}>
                    <Typography variant="body2">{statusFilter}</Typography>
                </LocalizedEnum>
            )}
            {floor !== ALL_FLOORS && <Typography variant="body2">{floor}</Typography>}
            {view === MeetingRoomsView.STATUS && <Typography variant="body2">{hourLabel}</Typography>}
            <LocalizedStrict
                id="service-center-meeting-rooms-table-footer-count"
                vars={{ shown: shownRooms, total: totalRooms }}
            >
                <Typography variant="body2">
                    Showing {shownRooms} of {totalRooms} rooms
                </Typography>
            </LocalizedStrict>
            {summaryMessages.map((message) => (
                <Typography key={message} variant="body2">
                    {message}
                </Typography>
            ))}
        </Stack>
    )
}
